import suiteService from 'qreventos-suite/services';

class SuiteConfig {
    evento:number = 770;
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4STNneDZuYncvaUZnVTl4cU9kQjlXaz0=';
    clientId: string = '6cb93876-7193-4049-b930-557703041651-508';

    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  
    }
}

export default new SuiteConfig();
